<template>
    <div>
        <div class="ibox animated fadeInRightBig">
            <div class="ibox-title">
                <h3>Novo Check-List <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i>
                </h3>
            </div>
            <form id="form">
                <div class="ibox-content">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label for="name"><span class="required">*</span> Nome do Check-List</label>
                            <input type="text" class="form-control" name="name" v-model="checklist.name" id="name">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h4>Itens do Check-List</h4>
                            <button type="button" class="btn btn-primary" @click="addItem"><i class="fa fa-plus"></i></button>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Descrição</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in checklist.items" :key="index">
                                        <td>
                                            <input type="text" class="form-control" v-model="item.title"
                                                placeholder="Nome do Item">
                                        </td>
                                        <td>
                                            <input type="text" class="form-control" v-model="item.description"
                                                placeholder="Descrição do Item">
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-danger"
                                                @click="removeItem(index)"> <i class="fa fa-trash"></i> </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            
                        </div>
                    </div>
                </div>
                <div class="ibox-footer">
                    <div class="pull-right">
                        <router-link to="/checklists" class="btn btn-info">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                    <p><span class="required">*</span> Campos Obrigatórios</p>
                    <div class="clearfix"></div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            branches: [],
            checklist: {
                name: '',
                items: []
            },
            errors: undefined
        }
    },
    computed: {},
    mounted() {

    },
    methods: {
        addItem() {
            this.checklist.items.push({ name: '', description: '' });
        },
        removeItem(index) {
            this.checklist.items.splice(index, 1);
        },
        save: function () {
            const self = this;
            const api = self.$store.state.api + 'checklists';

            let form = new FormData();
            form.append('name', self.checklist.name);

            // Adiciona os itens do checklist ao form data
            self.checklist.items.forEach((item, index) => {
                form.append(`items[${index}][title]`, item.title);
                form.append(`items[${index}][description]`, item.description);
            });

            self.$http.post(api, form)
                .then((response) => {

                    self.$message('Sucesso', `Check-List cadastrado com sucesso`, 'success');

                    this.$router.push('/checklists');

                })
                .catch((error) => {
                    self.errors = error.response.data;

                    if (typeof self.errors === 'object') {
                        let html = '<ul>';

                        $.each(self.errors, function (key, value) {
                            html += '<li>' + value[0] + '</li>';
                        });

                        html += '</ul>';

                        self.errors = html;
                    }

                    self.$message(null, self.errors, 'error');
                });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/CheckList/Add.vue